import React from 'react';
import i18next from 'i18next';
import { string, func, element, oneOfType, bool, object } from 'prop-types';
import cn from 'classnames';

import styles from './styles.module.scss';
import { ERROR_IMAGES } from './constants';

function ErrorContainer({
  action,
  actionButtonClasName,
  actionButtonText,
  title,
  message,
  className,
  children,
  img: Img,
  imgClassName,
  iconClassName,
  actionButtonLoading
}) {
  return (
    <div className={cn('column center middle text-center', styles.container, className)}>
      {iconClassName && <i className={iconClassName} />}
      {Img && <Img className={cn('m-bottom-4', styles.img, imgClassName)} />}
      <h3 className="subtitle-medium-semibold m-bottom-2">{title}</h3>
      <div className="column full-width">
        {message && <h4 className="text-base m-bottom-2">{message}</h4>}
        {children}
      </div>
      {action && (
        <button
          type="button"
          onClick={action}
          disabled={actionButtonLoading}
          className={cn(
            'button primary center row middle m-bottom-4',
            styles.actionButton,
            actionButtonClasName,
            { disabled: actionButtonLoading }
          )}>
          {actionButtonLoading && <span className="material-icons-outlined  m-right-1 m-left-1">loop </span>}
          {actionButtonText}
        </button>
      )}
    </div>
  );
}

ErrorContainer.defaultProps = {
  img: ERROR_IMAGES.WARNING,
  title: i18next.t('Error:defaultErrorTitle')
};

ErrorContainer.propTypes = {
  action: func,
  actionButtonClasName: string,
  actionButtonLoading: bool,
  actionButtonText: string,
  className: string,
  iconClassName: string,
  img: oneOfType([element, func, object]), // eslint-disable-line react/forbid-prop-types
  imgClassName: string,
  message: string,
  title: string
};

export default ErrorContainer;
